<template>
  <div>
    <purchases :id="order.id" :order="order" />
    <promotions :order="order" :partner="partner" />
    <div class="border" v-if="validate === true">
      <h4>
        {{ "order_price" | setText("Стоимость заказа") }}:
        {{ order.price_total | spaceBetweenNumber }} UZS
      </h4>

      <button
        @click="$emit('setStep', 'client-check')"
        class="btn btn-danger mb-5"
      >
        Редактировать данные клиента
      </button>

      <br />
      <div>
        <div class="mb-3">
          <label>{{
            "select_period_credit" | setText("Выберите период рассрочки")
          }}</label>

          <select
            :disabled="transaction.api_result"
            class="form-control"
            v-model="limit"
          >
            <option
              v-for="(cond, index) in partner.conditionals"
              :key="index"
              :value="cond"
            >
              <span>
                ({{ cond.exchange_id }}) {{ cond.month }}
                {{ "mo" | setText }}:</span
              >
              ~
              {{
                Math.round(
                  (order.price_total +
                    (order.price_total * cond.coefficient) / 100) /
                    cond.month,
                  2
                ) | spaceBetweenNumber
              }}
              UZS /
              {{ "mo" | setText }}
            </option>
          </select>
        </div>
        <div>
          <button
            @click="addOrder"
            :disabled="transaction.api_result"
            class="btn btn-info"
          >
            Применить
          </button>
        </div>
      </div>
      <div>
        <div class="install-control">
          <button
            @click="next"
            :disabled="!transaction.api_result"
            class="btn btn-success"
          >
            {{ "next_step" | setText("Далее") }}
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <h3 class="text-danger">
        {{ "order_error" | setText("Заказ не проходит условию") }}
      </h3>
      <h5>
        {{ "min_price_partner" | setText(" Минимальная цена заказа") }}:
        {{ partner.min_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "max_price_partner" | setText(" Максимальная цена заказа") }}:
        {{ partner.max_price | spaceBetweenNumber }} UZS
      </h5>
      <h5>
        {{ "min_qty_partner" | setText("Минимальное количество товаров") }}:
        {{ partner.min_amount_product | spaceBetweenNumber }} шт.
      </h5>
      <h5>
        {{ "max_qty_partner" | setText("Максимальное кличество товаров") }}:
        {{ partner.max_amount_product | spaceBetweenNumber }} шт.
      </h5>
    </div>
  </div>
</template>
<script>
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
import { logger, errorNotify } from "../../../plugins/functions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  computed: {
    validate() {
      if (this.partner.min_amount_product > this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_amount_product < this.order.quantity_total) {
        return false;
      }

      if (this.partner.max_price < this.order.price_total) {
        return false;
      }

      if (this.partner.min_price > this.order.price_total) {
        return false;
      }

      return true;
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    transaction: {
      default: function () {},
    },
    value: {
      default: null,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    async getProducts() {
      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      let products = [];
      if (this.order && this.order.purchases) {
        for (let i = 0; i < this.order.purchases.length; i++) {
          const localPurchase = this.order.purchases[i];

          let purchase = await this.$http
            .get(
              `${partner["endpoint_url"]}applications/alifshop?search=${localPurchase["barcode"]}`,
              {
                headers: {
                  Authorization: `Bearer ${partner["api_secret_key"]}`,
                  "Content-Type": "application/json",
                  Accept: "application/json",
                  locale: this.$store.state.language_current,
                },
              }
            )
            .then((response) => {
              try {
                return response.data.data[0];
              } catch (error) {
                return null;
              }
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
              return null;
            })
            .finally(() => {});

          if (purchase) {
            let p = {};
            p["good_type_name"] = purchase["category_name"];
            p["item_id"] = purchase["id"];
            p["ikpu"] = purchase["ikpu"];
            p["price"] = localPurchase["price"] * 100;
            p["good_name"] = localPurchase["name"];
            p["is_markable"] = false;
            p["sku"] = localPurchase["barcode"];

            for (let j = 0; j < localPurchase["quantity"]; j++) {
              products.push(p);
            }
          } else {
            alert("В базе парнера ALIF NASIYA не найден товар");
            return [];
          }
        }
      }
      return products;
    },
    async addOrder() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER
      const products = await this.getProducts();

      if (!this.limit["exchange_id"]) {
        alert("У лимита не установлен внешний ключ");
        return false;
      }

      this.$http
        .post(
          `${partner["endpoint_url"]}applications/applications/store-full`,
          {
            client_id: parseInt(this.transaction.exchange_additional_id),
            items: products,
            first_payment_date: null,
            prepayment: 0,
            condition_id: parseInt(this.limit["exchange_id"]),
            type: "in_store",
          },
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then(async (response) => {
          await this.createTransaction({
            api_result: JSON.stringify(response.data),
            exchange_id: response.data.id,
            percent: this.limit["coefficient"],
            month: this.limit["month"],
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async next() {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http
        .post(
          `${partner["endpoint_url"]}applications/applications/${this.transaction["exchange_id"]}/request-approval`,
          {},
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then(async (response) => {
          await this.createTransaction({
            step: "done",
          });
          this.$emit("setStep", "done");
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      limit: {},
    };
  },
};
</script>

